import { F_MapMarkerWallFragment, MapMarkerWallStructureType } from '__generated__v2/graphql';
import { MultiLineWall } from 'pages/special/OsloDesignFair/map/markers/view/WallMarker/MultiLineWall';
import { PolygonWall } from 'pages/special/OsloDesignFair/map/markers/view/WallMarker/PolygonWall';
import { RefObject } from 'react';
import { MapRef } from 'react-map-gl';

interface Props {
    marker: F_MapMarkerWallFragment;
    beforeId?: string;
    orderIndex: number;
    mapRef: RefObject<MapRef | null>;
}

export const WallMarker = (props: Props): JSX.Element => {
    const { marker } = props;

    if (
        marker.structureType === MapMarkerWallStructureType.Wall ||
        marker.transformedCoordinates.length < 3
    ) {
        return (
            <MultiLineWall
                mapRef={props.mapRef}
                marker={props.marker}
                beforeId={props.beforeId}
                orderIndex={props.orderIndex}
            />
        );
    }

    if (marker.structureType !== MapMarkerWallStructureType.Floor) {
        return (
            <PolygonWall
                mapRef={props.mapRef}
                marker={props.marker}
                beforeId={props.beforeId}
                orderIndex={props.orderIndex}
            />
        );
    }
};
